module.exports = __webpack_public_path__ + "0425a1118f81bfec5afe16bc8a35a059.svg";